import { Navigate } from 'react-router-dom'

import { unsetCurrentTenantConfig } from '..'
import { useAllProjectsByTenantId } from '../../../data/tenants'
import { ConfigurationSetter } from './ConfigurationSetter'

type ProjectConfiguratorProps = {
  tenantId: string
}

export const ProjectConfigurator: React.FC<ProjectConfiguratorProps> = ({
  tenantId,
}) => {
  const { data, error } = useAllProjectsByTenantId(tenantId)

  if (error) return <>{unsetCurrentTenantConfig() && <Navigate to="/" />}</>

  if (!data) return null

  return (
    <ConfigurationSetter
      tenantId={tenantId}
      projectId={data?.length === 1 ? data[0].Id : undefined}
    />
  )
}
